/* Alpacas Foods — Receitas: hover-play inline (mutado) + modal com som. */
class RecipeVideos extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('[data-recipe-modal]');
    this.stage = this.querySelector('[data-recipe-modal-stage]');
    this.closeBtn = this.querySelector('[data-recipe-modal-close]');
    this.activeTrigger = null;
    this.canHover =
      window.matchMedia('(hover: hover)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.querySelectorAll('[data-recipe-card]').forEach((card) => {
      const inline = card.querySelector('video');
      const trigger = card.querySelector('[data-recipe-play]');
      const area = card.querySelector('.alp-recipe-card__video');
      if (!trigger) return;
      if (this.canHover && inline) {
        card.addEventListener('pointerenter', () => inline.play().catch(() => {}));
        card.addEventListener('pointerleave', () => {
          inline.pause();
          try { inline.currentTime = 0; } catch (e) {}
        });
      }
      trigger.addEventListener('click', () => this.open(trigger, inline));
      if (area) {
        area.addEventListener('click', (e) => {
          if (e.target.closest('[data-recipe-play]')) return;
          this.open(trigger, inline);
        });
      }
    });

    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
    if (this.modal) {
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.close();
      });
    }
    this._onKey = (e) => {
      if (e.key === 'Escape' && this.isOpen()) this.close();
    };
    document.addEventListener('keydown', this._onKey);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKey);
  }

  isOpen() {
    return this.modal && !this.modal.hidden;
  }

  open(trigger, inline) {
    const src = trigger.getAttribute('data-video-src');
    if (!src || !this.modal || this.isOpen()) return;
    if (inline) inline.pause();
    this.activeTrigger = trigger;
    const v = document.createElement('video');
    v.src = src;
    v.controls = true;
    v.autoplay = true;
    v.playsInline = true;
    v.className = 'alp-recipe-modal__video';
    this.stage.appendChild(v);
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (this.closeBtn) this.closeBtn.focus();
    v.play().catch(() => {});
  }

  close() {
    if (!this.modal) return;
    this.modal.hidden = true;
    document.body.style.overflow = '';
    this.stage.replaceChildren();
    if (this.activeTrigger) this.activeTrigger.focus();
    this.activeTrigger = null;
  }
}
if (!customElements.get('recipe-videos')) {
  customElements.define('recipe-videos', RecipeVideos);
}
